// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/microburst-recovery-and-avoidance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/microburst-recovery-and-avoidance/microburst-recovery-and-avoidance.js';

mount([g0]);
